function CookieConsent({ cookieConsent, setCookieConsent }) {

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setCookieConsent("accepted");
    // 同意したタイミングで GA & AdSense スクリプト読み込みなど可能

  };

  // [拒否] ボタンクリック
  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setCookieConsent("declined");
    // 拒否した場合は GA & AdSense を読み込まない
  };

  // すでに同意 or 拒否済みの場合、バナー非表示
  if (cookieConsent === "accepted" || cookieConsent === "declined") return null;

  return (
    <div 
      style={{
        position: "fixed",
        bottom: "10%",
        width: "100%",
        backgroundColor: "#eee",
        padding: "16px",
        textAlign: "center",
        borderTop: "2px solid #ccc",
        zIndex: 9999
      }}
    >
      <p>
        当サイトでは、サービス向上および広告配信のためにCookieを使用しています。  
        続行するには「同意する」を選択してください。詳しくは<a href="https://childish-scarecrow-4b8.notion.site/17e45e4adc758009874ec5041ecf68c5">プライバシーポリシー</a>をご確認ください。
      </p>
      <button onClick={handleAccept} style={{ marginRight: "8px" }}>同意する</button>
      <button onClick={handleDecline}>同意しない</button>
    </div>
  );
}

export default CookieConsent;
